import React from "react";
import nunit_font from './nunito.light.ttf'
import nunit_font_bold from './nunito.bold.ttf'
import SignatureFont from './DancingScript-Regular.ttf'
import { Page, Text, Image, Document, View, Font, StyleSheet } from "@react-pdf/renderer";

Font.register({ family: 'Nunito', src: nunit_font });
Font.register({ family: 'Nunito-bold', src: nunit_font_bold });
Font.register({ family: 'SignatureFont', src: SignatureFont });

function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function File_header({ order_data }) {
    return (
        <View style={{
            width: '95%',
            display: 'flex',
            flexDirection: 'row',
            margin: '0 auto',
        }}>
            <View style={{
                width: '245px',
                height: '100%',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'flex-start'
            }}>
                <Image style={{
                    height: '70px',
                    objectFit: 'scale-down'
                }} src={`data:image/*;base64,${order_data.company_logo}`} />
            </View>
            <View style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: 35,
            }}>
                <View style={{
                    width: '100%',
                    fontSize: 23,
                    fontWeight: '600',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    alignContent: 'flex-end',
                    paddingLeft: 11,
                    marginBottom: '5px',
                    fontFamily: 'Nunito-bold',
                    color: '#555555'
                }}><Text>Bon de Commande</Text></View>
                <View style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: 9,
                    paddingLeft: 13,
                }}>
                    <View style={{
                        margin: '1px 0px',
                        display: 'flex',
                        flexDirection: 'row',
                    }}>
                        <Text style={{
                            fontFamily: 'Nunito-bold',
                        }}>Numéro de la commande : </Text>
                        <Text>{order_data.order_number}</Text>
                    </View>
                    <View style={{
                        margin: '1px 0px',
                        display: 'flex',
                        flexDirection: 'row',
                    }}>
                        <Text style={{
                            fontFamily: 'Nunito-bold',
                        }}>Date de la commande : </Text>
                        <Text>{(new Date(order_data.request_infos.order_created_at)).toLocaleDateString().split(',')[0]}</Text>
                    </View>
                    {/*  <View style={{ 
                    margin:'1px 0px',
                    display:'flex',
                    flexDirection:'row',
                    }}>
                    <Text style={{
                        fontFamily:'Nunito-bold',
                    }}>Date de livraison : </Text>
                    <Text>{order_data.request_infos.delivery_supposedDate?(new Date(order_data.request_infos.delivery_supposedDate).toLocaleDateString().split(',')[0]):"-"}</Text>
                </View> */}
                </View>
            </View>
        </View>
    );
}



function Company_infos({ company_infos }) {
    return (
        <View style={{
            width: '95%',
            display: 'flex',
            flexDirection: 'row',
            margin: '12px auto 5px auto',
        }}>
            <View style={{
                width: '220px',
                display: 'flex',
                fontSize: 9,
                flexDirection: 'column',
            }}>
                <View style={{
                    width: '100%',
                    fontSize: '16pt',
                    marginBottom: '2px',
                    fontFamily: 'Nunito-bold',
                    color: '#555555'
                }}>
                    <Text>{company_infos.company_name}</Text>
                </View>
                <View style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    color: '#555555',
                    paddingLeft: 1
                }}>
                    <Text style={{
                        marginBottom: 1
                    }}>{company_infos.country + ", " + company_infos.city}</Text>
                    <Text style={{
                        marginBottom: 1
                    }}>{company_infos.address + ", " + company_infos.postcode}</Text>
                    <View style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: 1
                    }}>
                        <Text>Télephone : </Text>
                        <Text style={{
                            color: '#555555'
                        }}>{company_infos.phoneNumber}</Text>
                    </View>
                </View>
            </View>
        </View>
    )
}


function Personal_infos({ requester_infos }) {
    return (
        <View style={{
            width: '260px',
            display: 'flex',
            flexDirection: 'column',
            borderStyle: 'solid',
            borderWidth: 1,
            borderRadius: '5px',
        }}>
            <View style={{
                width: '100%',
                borderColor: "#999999",
                fontFamily: 'Nunito-bold',
                color: 'white',
                fontSize: 9,
                backgroundColor: '#999999',
                textTransform: 'uppercase',
                padding: '4px 9px',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
            }}><Text>Infos Demandeur</Text></View>
            <View style={{
                width: '100%',
                padding: '4px 9px',
                fontSize: 9,
            }}>
                <Text style={{
                    marginBottom: 1,
                    fontFamily: 'Nunito-bold',
                }}>{requester_infos.purchaseSrv_fullName}</Text>
                <Text>{requester_infos.delivery_country}, {requester_infos.delivery_city}</Text>
                <Text>{requester_infos.delivery_address}</Text>
                <Text>{requester_infos.delivery_postCode}</Text>
            </View>
        </View>
    );
}

function Imputation_infos({ requester_infos }) {
    return (
        <View style={{
            width: '260px',
            display: 'flex',
            flexDirection: 'column',
            borderStyle: 'solid',
            borderWidth: 1,
            borderRadius: '5px',
        }}>
            <View style={{
                width: '100%',
                borderColor: "#999999",
                color: 'white',
                fontSize: 9,
                fontFamily: 'Nunito-bold',
                backgroundColor: '#999999',
                textTransform: 'uppercase',
                padding: '4px 9px',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
            }}><Text>Imputation</Text></View>
            <View style={{
                width: '100%',
                padding: '4px 9px',
                fontSize: 9,
            }}>
                <Text style={{
                    marginBottom: 1,
                    fontFamily: 'Nunito-bold',
                }}>{requester_infos.request_code}</Text>
                <Text>{requester_infos.requester_fullName}</Text>
                <Text>{requester_infos.requester_direction}</Text>
                <Text>{requester_infos.project_title}</Text>
            </View>
        </View>
    );
}

function Supplier_infos({ supplier_infos }) {
    return (
        <View style={{
            width: '260px',
            display: 'flex',
            flexDirection: 'column',
            borderStyle: 'solid',
            borderWidth: 1,
            borderRadius: '5px',
        }}>
            <View style={{
                width: '100%',
                borderColor: "#999999",
                color: 'white',
                fontFamily: 'Nunito-bold',
                fontSize: 9,
                backgroundColor: '#999999',
                textTransform: 'uppercase',
                padding: '4px 9px',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
            }}><Text>Infos Fournisseur</Text></View>
            <View style={{
                width: '100%',
                padding: '4px 9px',
                fontSize: 9,
            }}>
                <Text style={{
                    marginBottom: 1,
                    fontFamily: 'Nunito-bold',
                }}>{supplier_infos.parentCompany}</Text>
                <Text>{supplier_infos.iceNumbner}</Text>
                <Text>{supplier_infos.country}, {supplier_infos.city}</Text>
                <Text>{supplier_infos.address}</Text>
                <Text>{supplier_infos.postcode}</Text>
                <Text>{supplier_infos.phoneNumber}</Text>
            </View>
        </View>
    );
}



function Table_body_elem({ product }) {
    return (
        <View style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottomWidth: .5,
            borderBottomStyle: 'solid',
            borderBottomColor: '#999999',
            color: '#555555',
            fontSize: 8.5,
            padding: '5px 0',
        }}>
            <View style={{
                width: '20%',
                padding: '0 4px'
            }}>
                <Text>{product.product_code}</Text>
            </View>
            <View style={{
                width: '35%',
                padding: '0 4px'
            }}>
                <Text>{product.title}</Text>
            </View>
            <View style={{
                width: '15%',
                padding: '0 4px'
            }}>
                <Text>{numberWithSpaces(product.product_price)}</Text>
            </View>
            <View style={{
                width: '12%',
                textAlign: 'center',
                padding: '0 4px'
            }}>
                <Text>{product.product_promo}</Text>
            </View>
            <View style={{
                width: '12%',
                textAlign: 'center',
                padding: '0 4px'
            }}>
                <Text>{numberWithSpaces(product.product_amount)}</Text>
            </View>
            <View style={{
                width: '17%',
                textAlign: 'right',
                padding: '0 4px'
            }}>
                <Text>{product.product_price !== '' && !isNaN(product.product_price)
                    ? numberWithSpaces(parseFloat((product.product_amount * (product.product_price - ((product.product_promo !== '' && !isNaN(product.product_promo)) ? (product.product_price * product.product_promo) / 100 : 0))).toFixed(2)))
                    : 0}</Text>
            </View>
        </View>
    );
}




function Other_order_pricesInfos({ title, data }) {
    return (
        <View style={{
            width: '40%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottomWidth: .5,
            borderBottomStyle: 'solid',
            fontSize: 9,
            padding: '5px 0'
        }}>
            <View style={{
                width: '55%',
                paddingLeft: '4px',
                fontFamily: 'Nunito-bold'
            }}>
                <Text>{title}</Text>
            </View>
            <View style={{
                width: '45%',
                color: '#555555',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingRight: '4px'
            }}>
                <Text>{data}</Text>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '170px',
        height: '80px',
        display: 'flex',
        flexDirection: 'column',
        borderStyle: 'solid',
        borderWidth: 0.6,
        justifyContent: 'space-between'
    },
    header: {
        width: '100%',
        fontSize: 9,
        fontFamily: 'Nunito-bold',
        textTransform: 'uppercase',
        padding: '4px 9px'
    },
    signature: {
        fontSize: 16,
        fontFamily: 'SignatureFont',
        textAlign: 'center',
        marginBottom: 15
    }
});

function Signature_requester({ requester_fullName }) {
    return (
        <View style={[styles.container, { marginLeft:"12px"}]}>
            <View style={styles.header}>
                <Text>Demandeur</Text>
            </View>

            <Text style={styles.signature}>
                {requester_fullName}
            </Text>
        </View>
    );
}

function Signature_purchase_srv() {
    return (
        <View style={[styles.container, { marginLeft:"12px"}]}>
            <View style={styles.header}>
                <Text>Service Achat</Text></View>
        </View>
    );
}

function Signature_direction() {
    return (
        <View style={[styles.container, { marginRight:"12px", marginLeft:"12px"}]}>
            <View style={styles.header}>
                <Text>Direction Générale</Text></View>
        </View>
    );
}

const Order_form_header_pdf = ({ order_data }) => {
    return (
        <Document>
            <Page style={{
                width: '100%',
                paddingBottom: 6,
                paddingTop: 15,
                paddingRight: 10,
                paddingLeft: 10,
                paddingHorizontal: 10,
                backgroundColor: "#f7f7f7",
                fontFamily: 'Nunito',
                color: '#555555'
            }}>

                <File_header order_data={order_data} />
                <Company_infos company_infos={order_data.company_infos} />
                <View style={{
                    width: '100%',
                    display: 'flex',
                    fontSize: '12pt',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '20px',
                    padding: "0 16px"
                }}>
                    <Personal_infos requester_infos={order_data.requester_infos} />
                    <Supplier_infos supplier_infos={order_data.supplier_infos} />
                </View>

                <View style={{
                    width: '100%',
                    display: 'flex',
                    fontSize: '12pt',
                    flexDirection: 'row',
                    marginTop: "10px",
                    marginBottom: "20px",
                    padding: "0 16px"
                }}>
                    <Imputation_infos requester_infos={order_data.requester_infos} />
                </View>

                <View style={{
                    width: '95%',
                    margin: '15px auto',
                }}>
                    <View style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottomWidth: .5,
                        borderBottomStyle: 'solid',
                        fontSize: 9,
                        padding: '5px 0',
                        fontFamily: 'Nunito-bold',
                    }}>
                        <View style={{
                            width: '20%',
                            padding: '0 4px'
                        }}>
                            <Text>Référence</Text>
                        </View>
                        <View style={{
                            width: '35%',
                            padding: '0 4px'
                        }}>
                            <Text>Produit</Text>
                        </View>
                        <View style={{
                            width: '15%',
                            padding: '0 4px'
                        }}>
                            <Text>P. unit. ({order_data.currency})</Text>
                        </View>
                        <View style={{
                            width: '12%',
                            textAlign: 'center',
                            padding: '0 4px'
                        }}>
                            <Text>Remise unit. (%)</Text>
                        </View>
                        <View style={{
                            width: '12%',
                            textAlign: 'center',
                            padding: '0 4px'
                        }}>
                            <Text>Quant.</Text>
                        </View>
                        <View style={{
                            width: '17%',
                            textAlign: 'right',
                            padding: '0 4px'
                        }}>
                            <Text>Total ({order_data.currency})</Text>
                        </View>
                    </View>
                    <>
                        {
                            order_data.products.map((product, id) => (
                                <Table_body_elem product={product} />
                            ))
                        }
                    </>
                </View>

                <View style={{
                    width: '95%',
                    margin: '0 auto 15px auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'flex-end',
                    alignItems: 'flex-end'
                }}>

                    <Other_order_pricesInfos title={"Total HT (" + order_data.currency + ")"} data={numberWithSpaces(order_data.total_ht)} />
                    <Other_order_pricesInfos title={"Taux de TVA (%)"} data={order_data.vat} />
                    <Other_order_pricesInfos title={"Frais d’expédition (%)"} data={order_data.shippingCosts} />
                    <Other_order_pricesInfos title={"Remise (%)"} data={order_data.discount} />
                    <Other_order_pricesInfos title={"Total TTC (" + order_data.currency + ")"} data={numberWithSpaces(order_data.total_ttc)} />

                </View>

                <View style={{
                    width: '100%',
                    display: 'flex',
                    fontSize: '12pt',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    position: "absolute",
                    bottom: 60,
                    padding: "0 0 0 12px"
                }}>
                    <Signature_requester requester_fullName={order_data.requester_infos.requester_fullName} />
                    <Signature_purchase_srv />
                    <Signature_direction />
                 </View>

                <Text
                    style={{
                        position: "absolute",
                        fontSize: 9.5,
                        bottom: 15,
                        left: 0,
                        right: 0,
                        textAlign: 'center',
                        color: "#555555",
                    }}
                    render={({ pageNumber, totalPages }) =>
                        `${pageNumber}/${totalPages}`
                    }
                />
            </Page>
        </Document>
    );
};

export default Order_form_header_pdf;